import Cookies from 'js-cookie';

const cookieName = 'ticker_toggle';
const stickyClass = 'js-sticky-header';
const $mainNavigation = jQuery('#main-navigation');
const $mainNavigationTrigger = jQuery('#main-navigation-sticky-trigger');
const mainNavigationHeight = $mainNavigation.outerHeight();
const $mainNavigationDropdown = document.querySelectorAll('.c-dropdown-container');

if (!Cookies.get(cookieName)) {
	document.body.classList.add('ticker-present');
}

if ($mainNavigationTrigger.length) {
	jQuery(window).scroll(function() { /* eslint-disable-line */
		if ((jQuery(window).scrollTop() - $mainNavigationTrigger.offset().top) >= 100) {
			$mainNavigation.addClass(stickyClass);
			jQuery('.c-dropdown-container').addClass('sticky');
			$mainNavigationTrigger.addClass('sticky');
		} else {
			$mainNavigation.removeClass(stickyClass);
			jQuery('.c-dropdown-container').removeClass('sticky');
			$mainNavigationTrigger.removeClass('sticky');
		}
	});
}

jQuery('.navigation-container__ul .with-dropdown-li').each(function() {
	jQuery('a', this).on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		jQuery(this).parent().siblings().find('a').removeClass('active');
		jQuery(this).toggleClass('active');
		jQuery('#' + jQuery(this).data('dropdown')).slideToggle({
			start: function() {
				jQuery(this).css('display', 'flex');
			},
		});
		jQuery('.c-dropdown-container:not(#' + jQuery(this).data('dropdown') + ')').hide();
	});
});

jQuery('.c-dropdown-container').on('click', function(e) {
	e.stopPropagation();
});

jQuery(window).click(function() {
	jQuery('.c-dropdown-container').slideUp();
	jQuery('.with-dropdown.active').removeClass('active');
});
